<div
	class="jepto-dimension-filter-dropdown__root"
	[attr.data-testid]="testId() ?? null"
>
	<button
		type="button"
		class="jepto-dimension-filter-dropdown__trigger"
		[disabled]="isTriggerNativeDisabled()"
		[attr.aria-disabled]="isMenuBlocked() ? true : null"
		[matMenuTriggerFor]="isMenuBlocked() ? null : filterMenu"
		[attr.aria-label]="
			isEmpty() ? 'Filter dropdown' : dimensionLabel() + ' filter'
		"
	>
		<span class="jepto-dimension-filter-dropdown__trigger-leading">
			@if (!isEmpty()) {
				@if (dimensionServiceSlug(); as svc) {
					@if (materialIconForService(svc); as matIcon) {
						<mat-icon
							class="jepto-dimension-filter-dropdown__service-icon jepto-dimension-filter-dropdown__service-icon--mat material-symbols-outlined"
							aria-hidden="true"
							>{{ matIcon }}</mat-icon
						>
					} @else if (iconAssetForService(svc); as icon) {
						<img
							class="jepto-dimension-filter-dropdown__service-icon"
							[src]="icon.src"
							[alt]="icon.alt"
							loading="lazy"
						/>
					}
				}
				<span class="jepto-dimension-filter-dropdown__title">{{
					dimensionLabel()
				}}</span>
				@if (summaryLabel()) {
					<span class="jepto-dimension-filter-dropdown__summary">{{
						summaryLabel()
					}}</span>
				}
			}
		</span>
		<span class="jepto-dimension-filter-dropdown__trigger-trailing">
			<span
				class="jepto-dimension-filter-dropdown__chevron icon-chevron-down"
				aria-hidden="true"
			></span>
		</span>
	</button>

	<mat-menu
		#filterMenu="matMenu"
		[class]="menuPanelClass()"
		(closed)="onMenuClosed()"
	>
		<div
			class="jepto-dimension-filter-dropdown__panel-inner"
			[class.jepto-dimension-filter-dropdown__panel-inner--dark]="
				isDark()
			"
			[style.--dimension-filter-bg]="themeColors().background"
			[style.--dimension-filter-border]="themeColors().borderSecondary"
			[style.--dimension-filter-text-primary]="themeColors().textPrimary"
			[style.--dimension-filter-text-secondary]="themeColors().textSecondary"
			[style.--dimension-filter-hover-mix]="themeColors().hoverMix"
			[style.--dimension-filter-accent]="themeColors().accent"
			[style.--dimension-filter-search-muted]="themeColors().textSecondary"
			[style.--dimension-filter-search-divider]="
				themeColors().borderSecondary
			"
			[style.background-color]="themeColors().background"
			[style.color]="themeColors().textPrimary"
			(click)="$event.stopPropagation()"
		>
			<div
				class="jepto-dimension-filter-dropdown__search-wrap"
				(click)="$event.stopPropagation()"
			>
				<span
					class="jepto-dimension-filter-dropdown__search-glyph icon-search"
					aria-hidden="true"
				></span>
				<input
					type="text"
					class="jepto-dimension-filter-dropdown__search-input"
					placeholder="Search"
					[disabled]="menuDisabled()"
					[attr.aria-label]="
						'Search ' + filterData().dimension.label
					"
					[value]="searchQuery()"
					(input)="onSearchInput($any($event.target).value)"
					(click)="$event.stopPropagation()"
					(keydown)="$event.stopPropagation()"
				/>
			</div>

			<div
				class="jepto-dimension-filter-dropdown__select-all"
				(click)="$event.stopPropagation()"
			>
				<mat-checkbox
					[disabled]="menuDisabled()"
					[checked]="allFilteredSelected()"
					[indeterminate]="someFilteredSelected()"
					(change)="onSelectAllFiltered($event.checked)"
					(click)="$event.stopPropagation()"
				>
					Select all
				</mat-checkbox>
			</div>

			<ul
				class="jepto-dimension-filter-dropdown__list"
				role="listbox"
				[attr.aria-label]="filterData().dimension.label + ' options'"
			>
				@for (option of filteredOptions(); track option.value) {
					<li class="jepto-dimension-filter-dropdown__row">
						<mat-checkbox
							[disabled]="menuDisabled()"
							[checked]="isOptionSelected(option.value)"
							(change)="
								onToggleOption(option.value, $event.checked)
							"
							(click)="$event.stopPropagation()"
						>
							{{ option.label }}
						</mat-checkbox>
					</li>
				} @empty {
					<li class="jepto-dimension-filter-dropdown__empty">
						No options
					</li>
				}
			</ul>
		</div>
	</mat-menu>
</div>
